import { useAuthentication } from './useAuthentication'

export function AuthenticatedTemplate(props: any) {
  const { isAuthenticated } = useAuthentication()
  if (isAuthenticated()) {
    return props.children
  }
  return null
}
